import { de } from '@/i18n/de';
import { useAppStore } from '@/lib/store';
import { wsClient } from '@/lib/wsClient';
import { Button } from '@/components/Button';

/**
 * Fragt die Runde, ob jemand ohne gültiges Token seinen Platz zurückbekommt.
 *
 * Bewusst mit ausgeschriebener Warnung: Eine Zustimmung gibt eine Geheimrolle
 * heraus, und ob hinter dem Namen die richtige Person steht, kann nur der
 * Mensch am Tisch beurteilen — nicht der Server.
 *
 * Liegt über allen Phasen, weil die Anfrage jederzeit eintreffen kann — und
 * verschwindet deshalb ohne Ausblend-Animation, sobald sie beantwortet ist:
 * eine liegengebliebene Tafel deckte sonst dauerhaft die Hauptaktion am
 * unteren Rand zu.
 */
export function RejoinRequestPrompt() {
  const requests = useAppStore((s) => s.rejoinRequests);
  const request = requests[0] ?? null;
  if (!request) return null;

  return (
    <div
      role="dialog"
      aria-live="polite"
      className="fixed inset-x-3 bottom-3 z-50 flex animate-phase-in flex-col gap-3 rounded-2xl border border-surface-border bg-surface-2 p-4 shadow-lg"
    >
      <p className="font-display font-semibold">{de.rejoin.promptTitle(request.playerName)}</p>
      <p className="text-sm text-fg-muted">{de.rejoin.promptWarning}</p>
      <div className="flex gap-2">
        <Button
          className="min-h-12 flex-1 text-sm"
          onClick={() => wsClient.send({ type: 'rejoin:approve', requestId: request.requestId })}
        >
          {de.rejoin.approve}
        </Button>
        <Button
          variant="danger-outline"
          className="min-h-12 flex-1 text-sm"
          onClick={() => wsClient.send({ type: 'rejoin:deny', requestId: request.requestId })}
        >
          {de.rejoin.deny}
        </Button>
      </div>
    </div>
  );
}
